import { render } from "./ThreadSection.vue?vue&type=template&id=588d22ee"
import script from "./ThreadSection.vue?vue&type=script&lang=js"
export * from "./ThreadSection.vue?vue&type=script&lang=js"

import "./ThreadSection.vue?vue&type=style&index=0&id=588d22ee&lang=scss"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__